// extracted by mini-css-extract-plugin
export default {"box":"ask-questions_box__h+Q4w"};